import {Reports} from "./ReportGeneratorActionConstants";
import authService from "../../auth/AuthService";

// Currently, this action is dispatched after every checkbox-select-unselect
// action on the list pages. This is to set the portal-display boolean to false
// and keep resetting it. There can be a better approach to solve this.
export const resetPDFPortal = () => ({
    type: Reports.RESET_PDF_PORTAL
})

const excelReportSuccess = (report, filename) => ({
    type: Reports.EXCEL_REPORT_SUCCESS,
    payload: {report, filename},
});

const pdfReportSuccess = (report, inputFields) => ({
    type: Reports.PDF_REPORT_SUCCESS,
    payload: {report, inputFields},
});

const generateExcelReport = (reportType, selectedServices, countryCodes, authToken) => ({
    type: Reports.EXCEL_REPORT,
    payload: {reportType, selectedServices, countryCodes, authToken},
});

const generateExcelReportForOneTenant = (useCase, requestPayload, authToken) => ({
    type: Reports.EXCEL_REPORT_FOR_ONE_TENANT,
    payload: {useCase, requestPayload, authToken},
});

const generateKYBXLSReport = (reportType, selectedServices, countryCodes, authToken) => ({
    type: Reports.KYB_EXCEL_REPORT,
    payload: {reportType, selectedServices, countryCodes, authToken},
});

const generateTenantsExcelReport = (serviceID, selectedCountry, serviceType, authToken) => ({
    type: Reports.ALL_TENANTS_EXCEL_REPORT,
    payload: {serviceID, selectedCountry, serviceType, authToken},
});

const generateKYBExcelReport = (type, authToken) => ({
    type: Reports.KYB_COUNTRY_COVERAGE_EXCEL_REPORT,
    payload: {type, authToken},
});

const generatePdfReport = (selectedServices, countryCodes, authToken) => ({
    type: Reports.PDF_REPORT,
    payload: {selectedServices, countryCodes, authToken},
});

const generatePdfReportForOneTenant = (requestPayload, authToken) => ({
    type: Reports.PDF_REPORT_FOR_ONE_TENANT,
    payload: {requestPayload, authToken},
});

const generateKybPdfReport = (selectedServices, countryCodes, authToken) => ({
    type: Reports.KYB_PDF_REPORT,
    payload: {selectedServices, countryCodes, authToken},
});

const generateCSVStyleReport = (recordIds, authToken) => ({
    type: Reports.CSV_REPORT,
    payload: {recordIds, authToken},
});

const getCountriesSourcesAction = (tenantIds, comparisonTenantId, authToken) => ({
    type: Reports.GET_COUNTRIES_SOURCES,
    payload: { tenantIds, comparisonTenantId, authToken }
})

const getPricingDataTenantsAction = (tenantIds, authToken) => ({
    type: Reports.GET_TENANTS_PRICING_DATA,
    payload: { tenantIds, authToken }
})

export function generateCountriesSourcesFromTenantIds(tenantIds, comparisonTenantId = "") {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getCountriesSourcesAction(tenantIds, comparisonTenantId, authToken));
    }
}

const generateKYBCSVStyleReport = (recordIds, authToken) => ({
    type: Reports.KYB_CSV_REPORT,
    payload: {recordIds, authToken},
});

export function getPricingDataForTenants(tenantIds) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getPricingDataTenantsAction(tenantIds, authToken));
    }
}

const csvReportSuccess = (report, filename) => ({
    type: Reports.CSV_REPORT_SUCCESS,
    payload: {report, filename},
});


// CSV Report Actions
export function generateCSVReport(recordIds) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generateCSVStyleReport(recordIds, authToken))
    }
}

export function generateCSVReportSuccess(report, filename) {
    return (dispatch) => {
        dispatch(csvReportSuccess(report, filename))
    }
}

// KYB CSV Report Actions
export function generateKYBCSVReport(recordIds) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generateKYBCSVStyleReport(recordIds, authToken))
    }
}


// Excel Report Actions
export function generateXLSReport(reportType, selectedServices, countryCodes, serviceType) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        serviceType === 'kyc'
            ? dispatch(generateExcelReport(reportType, selectedServices, countryCodes, authToken))
            : dispatch(generateKYBXLSReport(reportType, selectedServices, countryCodes, authToken))
    }
}

export function generateXLSReportForOneTenant(useCase, requestPayload) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generateExcelReportForOneTenant(useCase, requestPayload, authToken));
    }
}

// action to export the tenants associated with a service
export function generateAllTenantsReport(serviceID, selectedCountry, serviceType) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generateTenantsExcelReport(serviceID, selectedCountry, serviceType, authToken))
    }
}

// this action is not used currently as we do not have any KYB related data entered in the DB.
export function generateKYBCountryCoverageReport(type) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generateKYBExcelReport(type, authToken))
    }
}

export function generateExcelReportSuccess(report, filename) {
    return (dispatch) => {
        dispatch(excelReportSuccess(report, filename))
    }
}

// PDF Report Actions
export function generatePDFReport(selectedServices, countryCodes, serviceType) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        serviceType === 'kyc'
            ? dispatch(generatePdfReport(selectedServices, countryCodes, authToken))
            : dispatch(generateKybPdfReport(selectedServices, countryCodes, authToken))
    }
}

export function generatePDFReportForOneTenant(requestPayload) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(generatePdfReportForOneTenant(requestPayload, authToken))
    }
}

export function generatePDFReportSuccess(report, inputFields) {
    return (dispatch) => {
        dispatch(pdfReportSuccess(report, inputFields))
    }
}

const exports = {
    Reports,
}

export default exports;
